import IconDropdownIndicator from "assets/img/icon-dropdown-indicator.svg?react"

import { FC, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

import { TextVariable, TextVariableGroup } from "config/constants"
import { InfoDropdown, InfoDropdownList, InfoDropdownListItemButton } from "components/InfoDropdown"
import Button from "components/Button/Button"

interface IInsertTextVariableDropdownProps {
    onTextVariableSelect: (textVariable: TextVariable) => void
    textVariableGroup?: TextVariableGroup
}

const InsertTextVariableDropdown: FC<IInsertTextVariableDropdownProps> = ({
    onTextVariableSelect,
    textVariableGroup = TextVariableGroup.default
}) => {
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState(false)

    const dropdownItems = useMemo(() => {
        let items = Object.entries(TextVariable)

        const groupsWithInvoiceCounter = [
            TextVariableGroup.withInvoiceCounter,
            TextVariableGroup.withInvoiceCounterRequest,
            TextVariableGroup.withInvoiceCounterOffer,
        ]
        if (!groupsWithInvoiceCounter.includes(textVariableGroup)) {
            items = items.filter((item) => item[1] !== TextVariable.InvoiceCounter)
        }

        // remove request related text variables from the dropdown if the group is offerDocument
        if (textVariableGroup === TextVariableGroup.offerDocument) {
            items = items.filter(
                (item) =>
                    item[1] !== TextVariable.DeliveryAddress &&
                    item[1] !== TextVariable.StartDate &&
                    item[1] !== TextVariable.EndDate &&
                    item[1] !== TextVariable.RequestNumber
            )
        }

        if (textVariableGroup === TextVariableGroup.default) {
            items = items.filter(
                (item) => item[1] !== TextVariable.OfferNumber
            )
        }

        if (textVariableGroup === TextVariableGroup.withInvoiceCounterRequest) {
            items = items.filter((item) => item[1] !== TextVariable.OfferNumber)
        }

        if (textVariableGroup === TextVariableGroup.withInvoiceCounterOffer) {
            items = items.filter((item) => item[1] !== TextVariable.RequestNumber)
        }

        return items
    }, [textVariableGroup])

    return (
        <InfoDropdown
            label={
                <Button
                    theme="link"
                    label={t('textBuildingBlocks.insertTextVariable')}
                    icon={<IconDropdownIndicator className={isOpen ? "transform-rotate--180deg" : undefined} />}
                    iconPosition="end"
                    onClick={() => setIsOpen(true)}
                />
            }
            placement="bottom-start"
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            content={close => (
                <InfoDropdownList>
                    {dropdownItems.map(([key, value]) => (
                        <InfoDropdownListItemButton key={key} onClick={() => { close(); onTextVariableSelect(value) }}>
                            {t(`textVariable.${key}`)}
                        </InfoDropdownListItemButton>
                    ))}
                </InfoDropdownList>
            )}
        />
    )
}

export default InsertTextVariableDropdown
